import { Box, Typography } from "@mui/material";
import { getPrettyDate } from "../../../../../../utils/timestamp";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { dataStoreHasHistory } from "./checkRowsDataStore";

const DataStoreHistoryView = ({ entityData }) => {
  return (
    <Box>
      {dataStoreHasHistory(entityData) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          {(entityData?.aws_data?.creation_date ||
            entityData?.mongo_atlas_data?.create_date ||
            entityData?.snowflake_data?.creation_time ||
            entityData?.azure_sql_database_data?.creation_date ||
            entityData?.azure_storage_account_data?.creation_date ||
            entityData?.azure_blob_container_data?.creation_date ||
            entityData?.azure_file_share_data?.creation_date ||
            entityData?.azure_queue_data?.creation_date ||
            entityData?.azure_table_data?.creation_date ||
            entityData?.sentra_data?.creation_date ||
            entityData?.checkmarx_data?.created_at ||
            entityData?.github_data?.created_at) && (
            <>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <Typography variant={"subtitle2"}>Created On</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                {entityData?.aws_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.aws_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.mongo_atlas_data?.create_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.mongo_atlas_data?.create_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.snowflake_data?.creation_time && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.snowflake_data?.creation_time}
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_sql_database_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.azure_sql_database_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_storage_account_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={
                      entityData?.azure_storage_account_data?.creation_date
                    }
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_blob_container_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.azure_blob_container_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_file_share_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.azure_file_share_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_queue_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.azure_queue_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.azure_table_data?.creation_date && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.azure_table_data?.creation_date}
                  ></TextIntegrationStyle>
                )}
                {entityData?.sentra_data?.creation_date &&
                  !entityData?.aws_data?.creation_date && (
                    <TextIntegrationStyle
                      title={""}
                      value={entityData?.sentra_data?.creation_date}
                    ></TextIntegrationStyle>
                  )}
                {entityData?.checkmarx_data?.created_at && (
                  <TextIntegrationStyle
                    title={""}
                    value={getPrettyDate(
                      entityData.checkmarx_data.created_at.timestamp_utc
                    )}
                  />
                )}
                {entityData?.github_data?.created_at && (
                  <TextIntegrationStyle
                    title={""}
                    value={getPrettyDate(
                      entityData.github_data.created_at.timestamp_utc
                    )}
                  />
                )}
              </Box>
            </>
          )}
          {(entityData?.checkmarx_data?.updated_at ||
            entityData?.github_data?.updated_at) && (
            <>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <Typography variant={"subtitle2"}>Updated On</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                {entityData?.checkmarx_data?.updated_at && (
                  <TextIntegrationStyle
                    title={""}
                    value={getPrettyDate(
                      entityData.checkmarx_data.updated_at.timestamp_utc
                    )}
                  />
                )}
                {entityData?.github_data?.updated_at && (
                  <TextIntegrationStyle
                    title={""}
                    value={getPrettyDate(
                      entityData.github_data.updated_at.timestamp_utc
                    )}
                  />
                )}
              </Box>
            </>
          )}
          {(entityData?.sentra_data?.last_scanned ||
            entityData?.checkmarx_data?.last_scan) && (
            <>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <Typography variant={"subtitle2"}>Last Scanned</Typography>
              </Box>
              <Box ml={2} display={"flex"}>
                {entityData?.sentra_data?.last_scanned && (
                  <TextIntegrationStyle
                    title={""}
                    value={entityData?.sentra_data?.last_scanned}
                  ></TextIntegrationStyle>
                )}
                {entityData?.checkmarx_data?.last_scan && (
                  <TextIntegrationStyle
                    title={""}
                    value={getPrettyDate(
                      entityData.checkmarx_data.last_scan.timestamp_utc
                    )}
                  />
                )}
              </Box>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DataStoreHistoryView;
